import { css } from '@emotion/react';
import styled from '@emotion/styled';
import React, { FC } from 'react';
import { Warning } from '../../icon';
import { Typography } from '../../typography/Typography';
import { createMarkup } from '../../../utils';

export interface FormErrorProps {
  message: string | undefined;
  inline?: boolean;
  display?: boolean;
  errorMessageElementId?: string;
}

const StyledFormError = styled(Typography)<{
  $display?: boolean;
  inline: boolean;
}>`
  ${({ theme: { space, colors }, inline, $display }) => css`
    display: ${inline ? 'inline-block' : 'flex'};
    align-items: flex-start;
    gap: ${space.xxSmall};
    color: ${colors.systemError};
    white-space: pre-wrap;

    a {
      text-decoration: underline;
    }

    ${!$display &&
    css`
      display: none;
    `}
  `}
`;

const StyledWarning = styled(Warning)`
  ${({ theme: { space } }) => css`
    height: ${space.medium};
    position: relative;
    width: ${space.medium};
  `}
`;

export const FormError: FC<
  React.PropsWithChildren<FormErrorProps> & Partial<HTMLDivElement>
> = ({ message, inline = false, display, errorMessageElementId }) =>
  message &&
  display && (
    <StyledFormError
      id={errorMessageElementId || undefined}
      variant="bodyMedium"
      $display={!!(message && display)}
      inline={inline}
      role="alert"
      aria-live="assertive"
    >
      {message && display ? (
        <>
          <Typography component="span" visuallyHidden>
            Error:
          </Typography>
          <StyledWarning aria-hidden="true" />
          {createMarkup(message)}
        </>
      ) : (
        ''
      )}
    </StyledFormError>
  );
